import { i18n } from "./vue-i18n";
import { defineRule } from "vee-validate";
import { required, numeric } from "@vee-validate/rules";

// "required" rule
defineRule("required", (value) => {
  if (required(value)) {
    return true;
  }

  return i18n.global.t('validationMessages.required');
});


// "length" rule
defineRule('length', (value, [length]) => {
  if (value.length == length) {
    return true;
  }

  return i18n.global.t('validationMessages.length', { length });
});

// "numeric" rule
defineRule('numeric', (value) => {
  if (!numeric(value)) {
    return i18n.global.t('validationMessages.numeric');
  }
  return true;
});

// Custom "rvn" rule
defineRule('rvn', (value) => {
  if (!value.match(/^\d{8}[A-Z]\d{3}$/i)) {
    return i18n.global.t('validationMessages.rvn');
  }
  return true;
});

// "max" rule
defineRule('max', (value, [max]) => {
  if (value.length > max) {
    return i18n.global.t('validationMessages.maxLength', { max });
  }
  return true;
});

// "DE_zip" rule
defineRule('DE_zip', (value, [country]) => {
  if (country === "DE" && !value.match(/^\d{5}$/)) {
    return i18n.global.t('validationMessages.invalidDEZip');
  }
  return true;
});
